import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const getSettingGroupMenu = () => {
  return httpClient.get(server.SETTING_GROUP_MENU_URL + `/get`);
};

export const getSettingGroupMenu_ById = (id) => {
  return httpClient.get(
    server.SETTING_GROUP_MENU_URL + `/getbyid/${id}`
  );
};
export const getSettingGroupMenu_By_CompanyID = (id) => {
  return httpClient.get(
    server.SETTING_GROUP_MENU_URL + `/get_By_CompanyID/${id}`
  );
};

export const updateSettingGroupMenu = (id, data) => {
  return httpClient.put(server.SETTING_GROUP_MENU_URL + `/${id}`, data);
};

export const createSettingGroupMenu = (data) => {
  return httpClient.post(server.SETTING_GROUP_MENU_URL, data);
};

export const deleteSettingGroupMenu = (id) => {
  return httpClient.delete(server.SETTING_GROUP_MENU_URL + `/${id}`);
};
